// Dynamic generation of static completion terms for search functionality
// Terms are generated based on sales channel mappings

// Sales Channels IDs enum
const SC_ID = {
    A24: 'a24',
    AT: 'at',
    KCOM: 'kcom',
    TIRENDO: 'tirendo',
    OTC: 'otc',
};

const SCHEMA_BY_SCID = {
    'www-autoteile24-de': SC_ID.A24,
    'www-k24-at': SC_ID.AT,
    'www-kfzteile-com': SC_ID.KCOM,
    'sis_tirendo-delticom-de': SC_ID.TIRENDO,
    'otc_branch1-kfzteile24-de': SC_ID.OTC,
    'otc_branch2-kfzteile24-de': SC_ID.OTC,
    'otc_branch3-kfzteile24-de': SC_ID.OTC,
};

const URL_PREFIXES = {
    [SC_ID.A24]: '/ersatzteile-verschleissteile/',
    [SC_ID.KCOM]: '/autoteile/',
    [SC_ID.AT]: '/kategorie/ersatzteile-verschleissteile/',
    [SC_ID.TIRENDO]: '/kategorie/autoteile/',
    [SC_ID.OTC]: '/kategorie/autoteile/',
};

const BASE_TERMS = [
    { genart: 402, label: 'Bremsbeläge', urlSuffix: 'bremsanlage/bremsbelaege' },
    { genart: 82, label: 'Bremssattel', urlSuffix: 'bremsanlage/bremssattel/bremssattel-halter-traeger' },
    { genart: 78, label: 'Bremsscheiben', urlSuffix: 'bremsanlage/bremsscheiben' },
    { genart: 273, label: 'Lenker / Querlenker', urlSuffix: 'achsaufhaengung/lenker-querlenker/lenker-quer-laengs-schraeg' },
    { genart: 8, label: 'Luftfilter', urlSuffix: 'filter/luftfilter' },
    { genart: 7, label: 'Ölfilter', urlSuffix: 'filter/oelfilter' },
    { genart: 654, label: 'Radlagersatz', urlSuffix: 'achsaufhaengung/radnabe-radlager/radlager' },
];

// Schema specific urlSuffix overrides for terms that differ from default
const URL_SUFFIXES_OVERRIDES = {
    [SC_ID.KCOM]: {
        402: 'bremsanlage/scheibenbremse/bremsbelag/-bremsbelagsatz-scheibenbremse',
        82: 'bremsanlage/bremssattel/bremssattel-haltertraeger/-bremssattel',
        78: 'bremsanlage/scheibenbremse/bremsscheibe/-bremsscheibe',
        273: 'achsaufhaengungradfuehrungraeder/lenkerlenkerlagerung/lenker-quer-laengs-schraeg-/-lenker-radaufhaengung',
        654: 'achsaufhaengungradfuehrungraeder/radnabe-lagerung/radlager/-radlagersatz',
    }
};

export function getStaticCompletions(salesChannelId) {
    const schemaName = SCHEMA_BY_SCID[salesChannelId];
    const prefix = URL_PREFIXES[schemaName] || '';
    const urlSuffixesOverrides = URL_SUFFIXES_OVERRIDES[schemaName] || null;

    return BASE_TERMS.map(term => ({
        ...term,
        value: term.label,
        searchType: 'static',
        url: prefix + (urlSuffixesOverrides?.[term.genart] || term.urlSuffix || ''),
    }));
}
